

import __layout_0 from '/workspace/src/layouts/default.vue'
export const layouts = {
'about': () => import('/workspace/src/layouts/about.vue'),
'appletslay': () => import('/workspace/src/layouts/appletslay.vue'),
'checkout': () => import('/workspace/src/layouts/checkout.vue'),
'construction': () => import('/workspace/src/layouts/construction.vue'),
'default': __layout_0,
'signup': () => import('/workspace/src/layouts/signup.vue'),
'testwork': () => import('/workspace/src/layouts/testwork.vue'),
'videoEditorLayout': () => import('/workspace/src/layouts/videoEditorLayout.vue'),
'workspacebar': () => import('/workspace/src/layouts/workspacebar.vue'),
}

export function setupLayouts(routes) {
  return routes.map(route => {
    return { 
      path: route.path,
      component: layouts[route.meta?.layout || 'default'],
      children: [ {...route, path: ''} ],
    }
  })
}
